const removeBasePath = (path: string): string => {
  // /dpl/c/some/path ->  /some/path
  return `/${path.split('/').slice(3).join('/')}`
}

export default removeBasePath
